import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ShuffleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"shuffle"}/>
}
